module.exports = __webpack_public_path__ + "img/red-trash-icon.28f1231f.svg";